import React from 'react';
import { ChipBadge, ChipButton } from './styled_components';
import { ScopeInfo } from './types';

type ReadOnlyProps = {
  scope: ScopeInfo;
  readOnly: true;
};

type EditableProps = {
  scope: ScopeInfo;
  readOnly?: false;
  selected: boolean;
  onToggle: (name: string) => void;
};

type Props = ReadOnlyProps | EditableProps;

export default function ScopeActionChip(props: Props) {
  const { scope } = props;

  if (props.readOnly) {
    return <ChipBadge $risk={scope.risk}>{scope.actionLabel}</ChipBadge>;
  }

  return (
    <ChipButton
      type="button"
      aria-pressed={props.selected}
      aria-label={`${scope.actionLabel} — ${scope.name}`}
      $risk={scope.risk}
      $selected={props.selected}
      onClick={() => props.onToggle(scope.name)}
    >
      {scope.actionLabel}
    </ChipButton>
  );
}
